import { translate } from "../../i18n";

export function displayErrors(errors): string[] {
  return Object.entries(errors).map(([key, value]: [string, string]) =>
    translate(value),
  );
}
